// `CopyfitNotes.remarks` (SuiteIntegrations/CopyfitNotes.swift): print preflight's copyfitting suggestions as margin
// remarks, each anchored by quoting the passage it's about. Placing them (anchored at the compile's checkpoint, after
// resolving the earlier set: `CopyfitNotes.place`) is the app's, through the core's review import.
import type { PreflightFinding } from '../preflight.ts';

export const COPYFIT_AUTHOR = 'Print preflight';

/** `ReviewedDocument.Remark` as the review importer takes it. */
export interface CopyfitRemark {
  /** Stable for the same finding, so placing a build's notes twice adds nothing. */
  id: string;
  author: string;
  date: Date;
  body: string;
  quote: string;
  context: string;
}

export function copyfitRemarks(findings: readonly PreflightFinding[], date = new Date()): CopyfitRemark[] {
  return findings.flatMap((f) => {
    if (f.copyfit === undefined || f.quote === undefined || f.quote === '') return [];
    return [{ id: `${f.code}-${f.page ?? 0}-${f.quote}`, author: COPYFIT_AUTHOR, date, body: `${f.message} ${f.copyfit}`, quote: f.quote, context: f.context ?? f.quote }];
  });
}
